export class RouteParameter {
  public static readonly INTEGRATION_GROUP_ID: string = "integrationGroupID"
  public static readonly PROJECT_ID: string = "projectID";
  public static readonly QUOTATION_ID: string = "quotationID";
  public static readonly FORECAST_ID: string = "forecastID";
}
